import { KYMW1310Component } from './kymw1310.component';
import { KYMW1310MultiPublishListModel } from './vo/kymw1310-multi-publish-list.model';
import { CellEditEndingEventArgs } from '@grapecity/wijmo.grid';

/**
 * Ｗ掲載設定画面の値を管理するクラス
 *
 * @export KYMW1310Model
 * @class KYMW1310Model
 */
export class KYMW1310Model {

  kymw1310Component: KYMW1310Component;

  public FLAG_ON: string = <string>'1';
  // 設定ボタン使用可否
  public registEnabled: boolean = <boolean>false;
  // 編集ロック
  public editLock: boolean = <boolean>false;
  // 受注コード
  public orderCode: string = <string>'';
  // Ｐコード
  public pCode: string = <string>'';
  // 商品名
  public guideGoodsName: string = <string>'';
  // 規格名
  public guideStandardName: string = <string>'';
  // 取扱フラグ（いばらき）
  public enableFlagIB: boolean = <boolean>false;
  // 取扱フラグ（とちぎ）
  public enableFlagTO: boolean = <boolean>false;
  // 取扱フラグ（ぐんま）
  public enableFlagGU: boolean = <boolean>false;
  // 取扱フラグ（ちば）
  public enableFlagTI: boolean = <boolean>false;
  // 取扱フラグ（さいたま）
  public enableFlagSA: boolean = <boolean>false;
  // 取扱フラグ（とうきょう）
  public enableFlagTK: boolean = <boolean>false;
  // 取扱フラグ（ながの）
  public enableFlagNA: boolean = <boolean>false;
  // 取扱フラグ（にいがた）
  public enableFlagNI: boolean = <boolean>false;
  // 取扱フラグ（クルコ）
  public enableFlagKU: boolean = <boolean>false;
  // 多重掲載設定一覧
  public multiPublishList: Array<any> = null;
  // 取扱可能生協数
  public enableCoopCount: number = <number>0;

  public kymw1310MultiPublishListVO: KYMW1310MultiPublishListModel = new KYMW1310MultiPublishListModel();

  public enableFlagALL: boolean = <boolean>false;

  /**
   * サーバ取得データを反映する
   *
   * @param serverData サーバ取得データ
   */
  public updateKYMW1310(serverData: any): void {
    // 設定ボタン使用可否
    this.registEnabled = this.editLock;
    // 商品名
    this.guideGoodsName = serverData.GuideGoodsName;
    // 規格名
    this.guideStandardName = serverData.GuideStandardName;
    // 取扱フラグ（いばらき）
    if (serverData.EnableFlagIB === this.FLAG_ON) {
      this.enableFlagIB = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（とちぎ）
    if (serverData.EnableFlagTO === this.FLAG_ON) {
      this.enableFlagTO = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（ぐんま）
    if (serverData.EnableFlagGU === this.FLAG_ON) {
      this.enableFlagGU = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（ちば）
    if (serverData.EnableFlagTI === this.FLAG_ON) {
      this.enableFlagTI = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（さいたま）
    if (serverData.EnableFlagSA === this.FLAG_ON) {
      this.enableFlagSA = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（とうきょう）
    if (serverData.EnableFlagTK === this.FLAG_ON) {
      this.enableFlagTK = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（ながの）
    if (serverData.EnableFlagNA === this.FLAG_ON) {
      this.enableFlagNA = true;
      this.enableCoopCount++;
    }
    // 取扱フラグ（にいがた）
    if (serverData.EnableFlagNI === this.FLAG_ON) {
      this.enableFlagNI = true;
      this.enableCoopCount++;
    }

    // 取扱フラグ（クルコ）
    if (serverData.EnableFlagKU === this.FLAG_ON) {
      this.enableFlagKU = true;
      this.enableCoopCount++;
    }
    this.enableFlagALL = true;

    this.multiPublishList = new Array<any>();

    if (serverData.MultiPublishList instanceof Array) {
      for (let i = Number(0); i < serverData.MultiPublishList.length; i++) {
        this.multiPublishList.push(
          this.getMultiPublishListVO(serverData.MultiPublishList[i]));
      }
    } else {
      this.multiPublishList.push(
        this.getMultiPublishListVO(serverData.MultiPublishList));
    }
  }

  /* 多重掲載設定一覧を作成 */
  private getMultiPublishListVO(data: any): KYMW1310MultiPublishListModel {
    const vo: KYMW1310MultiPublishListModel = new KYMW1310MultiPublishListModel();
    let publishCoopCount = 0;

    // 媒体コード
    vo.mediumType = data.MediumType;
    // 媒体名
    vo.mediumName = data.MediumName;
    // 掲載フラグ（いばらき）
    if (data.PublishFlagIB === this.FLAG_ON) {
      vo.publishFlagIB = true;
      publishCoopCount++;
    }
    // 掲載フラグ（とちぎ）
    if (data.PublishFlagTO === this.FLAG_ON) {
      vo.publishFlagTO = true;
      publishCoopCount++;
    }
    // 掲載フラグ（ぐんま）
    if (data.PublishFlagGU === this.FLAG_ON) {
      vo.publishFlagGU = true;
      publishCoopCount++;
    }
    // 掲載フラグ（ちば）
    if (data.PublishFlagTI === this.FLAG_ON) {
      vo.publishFlagTI = true;
      publishCoopCount++;
    }
    // 掲載フラグ（さいたま）
    if (data.PublishFlagSA === this.FLAG_ON) {
      vo.publishFlagSA = true;
      publishCoopCount++;
    }
    // 掲載フラグ（とうきょう）
    if (data.PublishFlagTK === this.FLAG_ON) {
      vo.publishFlagTK = true;
      publishCoopCount++;
    }
    // 掲載フラグ（ながの）
    if (data.PublishFlagNA === this.FLAG_ON) {
      vo.publishFlagNA = true;
      publishCoopCount++;
    }
    // 掲載フラグ（にいがた）
    if (data.PublishFlagNI === this.FLAG_ON) {
      vo.publishFlagNI = true;
      publishCoopCount++;
    }
    // 掲載フラグ（クルコ）
    if (data.PublishFlagKU === this.FLAG_ON) {
      vo.publishFlagKU = true;
      publishCoopCount++;
    }
    if (this.enableCoopCount > 0 &&
      this.enableCoopCount === publishCoopCount) {
      // 全生協
      vo.publishFlagALL = true;
    }

    return vo;
  }
}
